import { useParams } from 'react-router-dom';
import { infoUpdateType } from 'types/notifications';
import { useSubscribeToSocketEvent } from './useSubscribeToSocketEvent';

const isInfoUpdateType = (data: unknown): data is infoUpdateType => {
  if (typeof data !== 'object' || data === null) return false;

  return (
    'email' in data && typeof data.email === 'string' &&
    'kind' in data && typeof data.kind === 'string' &&
    'name' in data && typeof data.name === 'string'
  );
};

export const useInfoUpdateEvent = (
  callback: (...args: any[]) => void,
  predicate?: (data: infoUpdateType) => boolean
) => {
  const { id: orderId } = useParams<{ id: string }>();

  useSubscribeToSocketEvent({
    eventKey: "info-update",
    callback,
    filter: (data: unknown) => {
      if (!isInfoUpdateType(data)) return false;
      if (!predicate) return true;

      return data.update?._id === orderId && predicate(data);
    },
  });
};
